import React, { useEffect } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { verifyOtp } from '../../store/authSlice';

const OTP = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tempEmail } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!tempEmail) {
      navigate('/login');
    }
  }, [tempEmail, navigate]);

  const onFinish = async (values) => {
    try {
      const resultAction = await dispatch(verifyOtp({ email: tempEmail, otp: values.otp }));
      const result = resultAction.payload;

      if (verifyOtp.fulfilled.match(resultAction)) {
        message.success('Verification successful');
        if (result.user.status === 'verified') {
          navigate('/bde/dashboard');
        } else {
          navigate('/pending');
        }
      } else {
        message.error(result || 'Invalid OTP');
      }
    } catch (err) {
      message.error('Verification failed: ' + err);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      position: 'relative',
      padding: '24px 0',
      overflowX: 'hidden'
    }}>
      {/* Decorative blobs */}
      <div style={{ position: 'absolute', top: -100, left: -100, width: 400, height: 400, background: '#2563eb', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>
      <div style={{ position: 'absolute', bottom: -100, right: -100, width: 400, height: 400, background: '#8b5cf6', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>

      <Card
        style={{ width: 400, border: '1px solid rgba(255,255,255,0.1)' }}
        styles={{ body: { padding: '32px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ color: '#fff', margin: 0, fontSize: 24 }}>VERIFICATION</h1>
          <p style={{ color: '#94a3b8', marginTop: 8 }}>Enter the OTP sent to {tempEmail}</p>
        </div>
        <Form
          name="otp"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            name="otp"
            label={<span style={{ color: '#94a3b8' }}>OTP</span>}
            rules={[{ required: true, message: 'Please input OTP!' }]}
          >
            <Input placeholder="Enter OTP" style={{ textAlign: 'center', letterSpacing: 8, fontSize: 24, height: 60 }} maxLength={4} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large" style={{ marginTop: 16 }}>
              Verify Account
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default OTP;
